
import React, { useState } from 'react';
import { Box, Paper, Container } from '@mui/material';
import PrimaryContent from '../../Utilities/PrimaryContent';
import PrimaryHeading from '../../Utilities/PrimaryHeading';
import BaseTypography from '../../Utilities/BaseTypography';

export default function AIDrivenRootCause() {

  const data = [
    { id: 'NDRC', title: 'Non-Detected Root Cause', description: 'Uncovering how defective products managed to bypass detection.' },
    { id: 'PRC', title: 'Process Root Cause', description: 'Identifying failures within the operational process.' },
    { id: 'SRC', title: 'System Root Cause', description: 'Addressing any systemic issues that allowed the non-conformance to occur.' },
  ];
  const [hovered, setHovered] = useState(data[0].id);

  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        position: 'relative',
        minHeight: '700px',
        padding: '15px',
      }}
    >
      <Box
        sx={{
          zIndex: 2,
          position: 'relative',
          padding: '20px',
          backgroundColor: 'transparent',
        }}
      >
        <Container maxWidth='xl'>
          <Box>
            <PrimaryHeading sx={{
              textAlign: { xs: 'center', md: 'left' },
              pb: 2
            }}><span style={{
              color: 'white',
              background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
              opacity: '90%',
              marginRight: '5px',
            }}>AI-driven</span>
              root cause analysis with 3RC Method
            </PrimaryHeading>
            <PrimaryContent variant="body1" sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 10 }}>
              To ensure complete issue resolution, NC pro employs the 3RC (Root Cause) method. This approach delves deep into three critical areas:
            </PrimaryContent>
          </Box>
        </Container>
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center', position: 'relative', padding: '10px 20px' }}>
            <Box
              sx={{
                position: 'relative',
                height: '200px',
                width: '100%',
              }}
            >
              <img
                src="/images/wave.png"
                alt="Wavy Line"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '0',
                  width: '100%',
                  zIndex: 0,
                  transform: 'translateY(-50%)',
                }}
              />
              {data.map((item, index) => (
                <Box
                  key={item.id}
                  sx={{
                    position: 'absolute',
                    top: index === 0 ? '10%' : index === 1 ? '100%' : '10%',
                    left: index === 0 ? '5%' : index === 1 ? '50%' : '95%',
                    transform: 'translate(-50%, -50%)',
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    background: hovered === item.id ? 'linear-gradient(#43B0D7, #0D2663)' : '#F0F7FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    cursor: 'pointer',
                    zIndex: 1,
                  }}
                  onMouseEnter={() => setHovered(item.id)}
                >
                  <BaseTypography
                    type="heading"
                    sx={{
                      fontSize: '30px',
                      color: hovered === item.id ? '#fff' : '#0D2663',
                    }}
                  >
                    {item.id}
                  </BaseTypography>
                  {hovered === item.id && (
                    <Paper
                      sx={{
                        position: 'absolute',
                        top: '120%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '300px',
                        padding: '10px',
                        textAlign: 'center',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                        zIndex: 2,
                        p: 4,
                        borderRadius: '20px'
                      }}
                    >
                      <PrimaryContent variant="subtitle1" sx={{ color: 'rgba(16, 59, 186, 1)', fontWeight: '700', fontStyle: 'italic', mb: 3 }}>
                        {item.title}
                      </PrimaryContent>
                      <hr style={{ border: '1px solid rgba(230, 247, 253, 1)', borderWidth: '1px', marginBottom: '18px' }} />
                      <PrimaryContent>
                        {item.description}
                      </PrimaryContent>
                    </Paper>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: 20,
          right: 0,
          width: '300px',
          height: '300px',
          backgroundImage: `url('/images/networkImage.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left bottom',
          zIndex: 1,
        }}
      />
    </Container>
  )
}